import React from 'react'
import { Route, Link as RouterLink, useLocation } from 'react-router-dom'
import {
	useDisclosure,
	Text,
	Link,
	Box,
	Container,
	VStack,
	Flex,
	Button,
	useColorModeValue,
} from '@chakra-ui/react'

import AppHeader from './Components/AppHeader'
import ColorModeToggle from './Components/ColorModeToggle'
import Home from './Pages/Home'
import Picker from './Pages/Picker'
import Pick5 from './Pages/Pick5'
import Modal from './Components/BGModal'
import Ranking from './Pages/Ranking'
import HowTo from './Pages/HowTo'
import Uoa from './Pages/Uoa'

import './App.css'

function App() {
	const { pathname } = useLocation()
	const { isOpen, onOpen, onClose } = useDisclosure()
	const footerRule = useColorModeValue('gray.200', 'whiteAlpha.300')
	const footerMuted = useColorModeValue('gray.500', 'bgg.muted')
	const footerDot = useColorModeValue('gray.400', 'gray.500')
	const footerLink = useColorModeValue('brand.500', 'orange.200')
	const contentMaxW = pathname === '/ranking-engine' ? '1100px' : '720px'

	return (
		<Flex direction="column" minH="100vh">
			<AppHeader />

			<Box as="main" flex="1" py={{ base: 8, md: 10 }} px={{ base: 4, md: 6 }}>
				<Container maxW={contentMaxW} px={0}>
					<Route exact path="/" component={Home} />
					<Route exact path="/game-picker" component={Picker} />
					<Route exact path="/pick-5" component={Pick5} />
					<Route exact path="/ranking-engine" component={Ranking} />
					<Route exact path="/how-to" component={HowTo} />
					<Route exact path="/uoa" component={Uoa} />
				</Container>
			</Box>

			<Box
				as="footer"
				borderTopWidth="1px"
				borderColor={footerRule}
				py={8}
				mt="auto"
			>
				<Container maxW={contentMaxW}>
					<VStack spacing={3} align="center" textAlign="center" fontSize="sm" color={footerMuted}>
						<Flex flexWrap="wrap" align="center" justify="center" gridColumnGap={3} gridRowGap={1}>
							<Link as={RouterLink} to="/" color={footerLink} fontWeight="500">
								Home
							</Link>
							<Text as="span" color={footerDot}>
								·
							</Text>
							<Link as={RouterLink} to="/game-picker" color={footerLink} fontWeight="500">
								Picker
							</Link>
							<Text as="span" color={footerDot}>
								·
							</Text>
							<Link as={RouterLink} to="/ranking-engine" color={footerLink} fontWeight="500">
								Ranking
							</Link>
							<Text as="span" color={footerDot}>
								·
							</Text>
							<Link as={RouterLink} to="/pick-5" color={footerLink} fontWeight="500">
								Pick 5
							</Link>
						</Flex>
						<Flex flexWrap="wrap" align="center" justify="center" gridColumnGap={3} gridRowGap={1}>
							<Link as={RouterLink} to="/how-to" color={footerLink} fontWeight="500">
								How to
							</Link>
							<Text as="span" color={footerDot}>
								·
							</Text>
							<Link
								href="https://github.com/alfremedpal/board-game-picker"
								isExternal
								color={footerLink}
							>
								Source
							</Link>
							<Text as="span" color={footerDot}>
								·
							</Text>
							<Button variant="link" size="sm" onClick={onOpen} color={footerLink} fontWeight="500">
								About
							</Button>
						</Flex>
						<Flex justify="center" w="full" pt={1}>
							<ColorModeToggle pl={0} ml={0} borderLeftWidth={0} />
						</Flex>
						<Text textAlign="center" color={footerMuted}>
							2026 © Vitekprchal.cz / powered by BGG XML API
						</Text>
						<Text textAlign="center" fontSize="xs" color={footerDot}>
							v0.4.0
						</Text>
					</VStack>
				</Container>
			</Box>

			<Modal isOpen={isOpen} onClose={onClose} />
		</Flex>
	)
}

export default App
